import { createResourceStore } from "@/lib/resource";
import type { User } from "./User";

export interface AuditLog {
  id: string;
  shop_id: string;
  user_id: string;
  user: User;
  action: string;
  auditable_type: string;
  auditable_id: string;

  previous_state: any;
  new_state: any;

  ip_address: string | null;
  user_agent: string | null;

  status: string;
  error_message: string | null;

  created_at: string | null;
  resource_name: string;
}

export const useAuditLog = createResourceStore<AuditLog>("audit-logs");
